'use client'
import React, { useEffect, useRef, useState } from 'react';
import Player from '@vimeo/player';
import css from './video.module.scss';

const CustomVimeoPlayer = ({ videoId, time }: { videoId: number, time?:number }) => {
    const vimeoRef = useRef(null);
    const [player, setPlayer] = useState<Player | null>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const vimeoPlayer = new Player(vimeoRef.current ?? "", {
            id: videoId,
            muted: false,
            background: true,
        });

        setPlayer(vimeoPlayer);

        const startTime = time ?? 0.4;
        vimeoPlayer.setCurrentTime(startTime);

        const onPlay = () => {
            setIsPlaying(true);
        };

        const onPause = () => {
            setIsPlaying(false);
        };

        vimeoPlayer.pause();

        vimeoPlayer.on('play', onPlay);
        vimeoPlayer.on('pause', onPause);

        return () => {
            vimeoPlayer.off('play', onPlay);
            vimeoPlayer.off('pause', onPause);
        };
    }, [time, videoId]);

    const handlePlayPause = () => {
        if (player) isPlaying ? player.pause() : player.play();
    };

    const handleMuteUnmute = () => {
        if (player) {
            player.setVolume(isMuted ? 1 : 0).then(() => setIsMuted(!isMuted));
        }
    };

    return (
        <div>
            <div
                className="responsive-video"
                style={{ paddingBottom: '56.25%', position: 'relative' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div ref={vimeoRef}></div>

                {(isHovered || !isPlaying) && (
                    <button onClick={handlePlayPause} className={css['vimeo__play-btn']}>
                        {isPlaying ? (
                            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="30" cy="30" r="30" fill="#FED30E"/>
                                <rect x="32" y="23" width="4" height="14" fill="#414042"/>
                                <rect x="24" y="23" width="4" height="14" fill="#414042"/>
                            </svg>
                        ) : (
                            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="30" cy="30" r="30" fill="#FED30E"/>
                                <path d="M27.0765 38.0765L27.0765 30.1005L27.0765 22.1247L38.8995 30.1005L27.0765 38.0765Z" fill="#414042"/>
                            </svg>
                        )}
                    </button>
                )}
                {(isHovered || !isPlaying) && (
                    <button onClick={handleMuteUnmute} className={css['vimeo__mute-btn']}>
                        {isMuted ? (
                            <svg width="30" height="30" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="30" cy="30" r="30" fill="#FED30E"/>
                                <path d="M22 24H28L34 18V42L28 36H22V24Z" fill="#414042"/>
                                <path d="M38 28C39 29 39 31 38 32" stroke="#414042" strokeWidth="2"/>
                                <path d="M36 26C37 27 37 33 36 34" stroke="#414042" strokeWidth="2"/>
                            </svg>
                        ) : (
                            <svg width="30" height="30" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="30" cy="30" r="30" fill="#FED30E"/>
                                <path d="M22 24H28L34 18V42L28 36H22V24Z" fill="#414042"/>
                                <path d="M34 26L40 34" stroke="#414042" strokeWidth="2"/>
                                <path d="M40 26L34 34" stroke="#414042" strokeWidth="2"/>
                            </svg>
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default CustomVimeoPlayer;
